<!-- HxCardLink Template -->
<hx-card [appearance]="appearance()" [title]="cardTitle()" [subtitle]="cardSubtitle()" [disabled]="disabledState()">
  <hx-card-content>
    <!-- Referral Toggle Row -->
    <div class="hx-card-link__toggle-row">
      <div class="hx-card-link__toggle-label">
        <span class="hx-card-link__referral-label">{{ referralLabel() }}</span>
        <span class="hx-card-link__referral-status">{{ referralMade() ? 'On' : 'Off' }}</span>
      </div>
      <hx-switch
        size="2xs"
        [(checked)]="referralMade"
        [disabled]="disabledState()"
        (checkedChange)="onReferralToggle($event)"
        [attr.aria-label]="referralLabel()" />
    </div>

    <!-- Notes Section (reserve height to keep cards even) -->
    <div
      class="hx-card-link__notes-section"
      [class.hx-card-link__notes-section--hidden]="!referralMade()"
      [attr.aria-hidden]="!referralMade()">
      <span class="hx-card-link__notes-label">
        {{ notesLabel() }}
        @if (notesRequired() && referralMade()) {
          <span class="hx-card-link__notes-required" aria-hidden="true">*</span>
        }
      </span>
      <div class="hx-card-link__notes-wrapper">
        <textarea
          #notesTextarea
          class="hx-card-link__notes-textarea"
          [class.hx-card-link__notes-textarea--with-dictation]="showDictation()"
          [placeholder]="notesPlaceholder()"
          [disabled]="disabledState()"
          [attr.tabindex]="referralMade() ? 0 : -1"
          [value]="referralNotes()"
          (input)="onNotesChange($any($event.target).value)"
          [attr.aria-label]="notesLabel()"></textarea>
        @if (showDictation()) {
          <button
            hxIconButton
            type="button"
            variant="ghost"
            context="neutral"
            size="xs"
            class="hx-card-link__dictation-button"
            [class.hx-card-link__dictation-button--listening]="dictationState() === 'listening'"
            [class.hx-card-link__dictation-button--error]="dictationState() === 'error'"
            [svgIcon]="dictationState() === 'listening' ? 'ccs-mic-fill' : 'ccs-mic'"
            [disabled]="disabledState() || !referralMade()"
            [attr.aria-pressed]="dictationState() === 'listening'"
            [attr.aria-label]="dictationButtonLabel()"
            [attr.title]="dictationButtonLabel()"
            (pointerenter)="onDictationButtonWarmUp()"
            (focus)="onDictationButtonWarmUp()"
            (click)="onDictationButtonClick($event)"></button>
        }
      </div>
    </div>

    <!-- Divider before link row -->
    <hx-divider variant="dashed" />

    <!-- Link CTA Row -->
    <div class="hx-card-link__link-row">
      <hx-link-button
        [label]="linkLabel()"
        [href]="sanitizedLinkUrl()"
        [target]="linkTarget()"
        size="sm"
        [disabled]="disabledState()"
        (click)="onLinkClick($event)" />
      @if (sanitizedLinkUrl()) {
        <button
          type="button"
          class="hx-card-link__copy-btn"
          [disabled]="disabledState()"
          [attr.aria-label]="'Copy link URL'"
          [class.hx-card-link__copy-btn--copied]="copied()"
          (click)="copyUrl()">
          <hx-icon [svgIcon]="copied() ? 'check2-square' : 'files'" />
        </button>
      }
    </div>
  </hx-card-content>
</hx-card>
